import React from "react";

interface Props {
  title: string;
  data?: {
    measurementStart?: string;
    measurementEnd?: string;
    totalDuration: number;
    target: number;
  };
  loading: boolean;
}

const formatDate = (date?: string) =>
  date ? new Date(date).toLocaleDateString() : "";

const cardBase =
  "bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md p-4";

const InsuranceEligibilityCard: React.FC<Props> = ({
  title,
  data,
  loading,
}) => {
  if (loading) {
    return (
      <div className={cardBase}>
        <h3 className="font-semibold text-gray-900 dark:text-gray-100">
          {title}
        </h3>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Loading Insurance Eligibility Tracker...
        </p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className={cardBase}>
        <p className="text-gray-600 dark:text-gray-400">
          No Data found for the Insurance Eligibility Tracker
        </p>
      </div>
    );
  }

  if (!data.measurementStart) {
    return (
      <div className={cardBase}>
        <h3 className="font-semibold text-gray-900 dark:text-gray-100">
          {title}
        </h3>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          You are not currently in a measurement period. To learn about health
          insurance eligibility visit your MySite Virtual Agent.
        </p>
      </div>
    );
  }

  const percent =
    data.target > 0
      ? (data.totalDuration / data.target) * 100
      : 0;

  return (
    <div className={cardBase}>
      <h3 className="font-semibold text-gray-900 dark:text-gray-100">
        {title}
      </h3>

      <div className="mt-2 space-y-2">
        <p className="text-gray-800 dark:text-gray-200">
          Measurement Period:{" "}
          <strong>
            {formatDate(data.measurementStart)} -{" "}
            {formatDate(data.measurementEnd)}
          </strong>
        </p>

        <p className="text-gray-800 dark:text-gray-200">
          Total Hours Completed:{" "}
          <strong>{data.totalDuration.toFixed(2)}</strong>
        </p>

        <p className="text-gray-800 dark:text-gray-200">
          Target Hours: <strong>{data.target}</strong>
        </p>

        {/* Progress bar */}
        <div className="w-full bg-gray-200 dark:bg-gray-700 h-4 rounded mt-2 overflow-hidden">
          <div
            className="bg-blue-500 dark:bg-blue-400 h-4 rounded transition-all duration-300"
            style={{ width: `${percent}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default InsuranceEligibilityCard;